import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getPublicVendors } from '../services/api';
import { useCustomerAuth } from '../services/CustomerAuthContext';
import { useAuth } from '../services/AuthContext';
import Header from '../components/Header';

function Artisans() {
  const [vendors, setVendors] = useState([]);
  const [search, setSearch] = useState('');
  const [pinnacle, setPinnacle] = useState(null);
  const { customer } = useCustomerAuth();
  const { vendor: loggedInVendor } = useAuth();
  const tier = customer?.subscriptionTier || 'explorer';
  const hasAccess = loggedInVendor || tier === 'member' || tier === 'enthusiast' || tier === 'insider';

  useEffect(() => {
    getPublicVendors()
      .then(data => setVendors(data.vendors || []))
      .catch(() => {});
    const API = process.env.REACT_APP_API_URL || 'https://rj2psn7fng.execute-api.us-east-1.amazonaws.com/v1';
    fetch(`${API}/pinnacle/active`).then(r => r.json()).then(data => { if (data.active) setPinnacle(data); }).catch(() => {});
  }, []);

  const filtered = vendors.filter(v => {
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return (v.businessName || '').toLowerCase().includes(q)
      || (v.specialty || '').toLowerCase().includes(q)
      || (v.skills || []).some(s => s.toLowerCase().includes(q));
  });

  return (
    <div className="artisans-page">
      <Header />
      <div className="artisans-content">

        {/* THE PINNACLE */}
        <div className="pinnacle-section">
          <h2 className="pinnacle-title">🏔️ The Pinnacle</h2>
          <p className="pinnacle-subtitle">This week's featured vendor</p>
          {pinnacle ? (
            <Link to={`/booth/${pinnacle.vendor.vendorId}`} style={{textDecoration:'none'}}>
              <div className="pinnacle-tile">
                <div className="pinnacle-flames"></div>
                <div className="pinnacle-content">
                  <div className="pinnacle-logo-wrap">
                    {pinnacle.vendor.profileImageUrl ? (
                      <img src={pinnacle.vendor.profileImageUrl} alt={pinnacle.vendor.vendorName} className="pinnacle-logo-img" />
                    ) : (
                      <div className="pinnacle-logo-placeholder">🪵</div>
                    )}
                  </div>
                  <h3 className="pinnacle-vendor-name">{pinnacle.vendor.vendorName}</h3>
                  <p className="pinnacle-vendor-specialty">{pinnacle.vendor.specialty}</p>
                </div>
              </div>
            </Link>
          ) : (
            <div className="pinnacle-tile">
              <div className="pinnacle-flames"></div>
              <div className="pinnacle-content">
                <div className="pinnacle-logo-wrap">
                  <div className="pinnacle-logo-placeholder">🪵</div>
                </div>
                <h3 className="pinnacle-vendor-name">Coming Soon</h3>
                <p className="pinnacle-vendor-specialty">The first Pinnacle vendor will be featured here</p>
              </div>
            </div>
          )}
        </div>

        <h2 className="section-title">Vendor Concourse</h2>
        <p className="section-subtitle">Browse every vendor booth on the concourse</p>
        <div className="artisan-search-bar">
          <input type="text" placeholder="Search by name, craft, or skill..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <div className="vendor-booth-grid">
          {filtered.length === 0 && <p className="empty-state">No vendors match your search.</p>}
          {filtered.map((vendor, i) => (
            <Link to={`/booth/${vendor.vendorId}`} className="vendor-booth-tile-link" key={i}>
            <div className="vendor-booth-tile">
              <div className="booth-tile-header">
                <div className="booth-tile-logo-wrap">
                  {vendor.profileImageUrl ? (
                    <img src={vendor.profileImageUrl} alt={vendor.businessName} className="booth-tile-logo" />
                  ) : (
                    <div className="booth-tile-logo-placeholder">🪵</div>
                  )}
                </div>
                <h3>{vendor.businessName}{vendor.liveStreamId && <span className="tile-live-dot"></span>}</h3>
                <p className="vendor-specialty">{vendor.specialty || 'Woodworking'}</p>
              </div>
              <div className="booth-tile-marquee">
                <div className={`marquee-track ${(vendor.itemPreviews || []).length > 3 ? 'animate' : ''}`}>
                  {(vendor.itemPreviews || []).map((item, idx) => (
                    <div className="marquee-thumb" key={idx}>
                      {item.images && item.images.length > 0 ? (
                        <img src={item.images[0].url} alt={item.name} />
                      ) : (
                        <div className="marquee-thumb-placeholder">🔨</div>
                      )}
                      <span className="marquee-thumb-price">${(item.price / 100).toFixed(2)}</span>
                    </div>
                  ))}
                  {(vendor.itemPreviews || []).length > 3 && (vendor.itemPreviews || []).map((item, idx) => (
                    <div className="marquee-thumb" key={`dup-${idx}`}>
                      {item.images && item.images.length > 0 ? (
                        <img src={item.images[0].url} alt={item.name} />
                      ) : (
                        <div className="marquee-thumb-placeholder">🔨</div>
                      )}
                      <span className="marquee-thumb-price">${(item.price / 100).toFixed(2)}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="booth-tile-footer">
                <span className="vendor-items-count">{vendor.publishedItems} item{vendor.publishedItems !== 1 ? 's' : ''}</span>
                {!hasAccess && <span className="lock-indicator">🔒</span>}
              </div>
            </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Artisans;
